import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import {
    FMToolbar,
    FMTable,
    FMTableHead,
    FMTableRow,
    FMTableCell,
    FMTableBody,
    FMContainer,
    FMFilterInput,
} from 'atoms';
import {
    DeviceInfo,
    KeyValueStringPair,
    SensorInfo,
    SensorInfoItemType,
} from 'features/FMDevicesInfo';
import style from './DevicesInfoPage.style';

interface OwnProps {
    deviceInfo: DeviceInfo;
    sensorCaptions: KeyValueStringPair[];
}

type Props = OwnProps & WithStyles;

interface State {
    sensors: SensorInfo[];
    sensorsFilterText: string;
}

class DeviceInfoPane extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {
            sensors: props.deviceInfo ? props.deviceInfo.sensors : [],
            sensorsFilterText: '',
        };
    }

    public componentDidUpdate(prevProps) {
        if (prevProps.deviceInfo !== this.props.deviceInfo) {
            let sensors = this.getFilteredSensors(this.props.deviceInfo.sensors, this.state.sensorsFilterText);
            this.setState({ sensors });
        }
    }

    private filterSensors = (text: string): void => {
        let lowerText = text.toLowerCase();
        let sensors = this.getFilteredSensors(this.props.deviceInfo.sensors, lowerText);
        this.setState({ sensors, sensorsFilterText: lowerText });
    }

    private getFilteredSensors = (sensors: SensorInfo[], text: string): SensorInfo[] => {
        if (typeof text !== 'string' || text.length < 1) {
            return sensors;
        }

        let newSensors = this.props.deviceInfo.sensors.filter(sensor => {
            for (let pair of sensor) {
                if (pair.key === SensorInfoItemType.name && pair.value.toLowerCase().indexOf(text) !== -1) {
                    return true;
                }
            }

            return false;
        });
        return newSensors;
    }

    public render() {
        if (this.props.deviceInfo === null) {
            return <div />;
        }

        return (
            <FMContainer square={true} className={this.props.classes.devicesListPane}>
                <FMToolbar>
                    <Typography variant="h5">
                        {this.props.deviceInfo.name} ({fmtools.translate('Module')} {this.props.deviceInfo.protocol})
                    </Typography>
                </FMToolbar>
                <FMToolbar className={this.props.classes.infoBlockTitle}>
                    <Typography variant="h6">{fmtools.translate('AvailableDataSource')}</Typography>
                    <FMToolbar variant="dense" style={{ marginLeft: 25 }}>
                        <FMFilterInput
                            placeholder={fmtools.translate('FilterByName')}
                            filter={this.filterSensors}
                        />
                    </FMToolbar>
                </FMToolbar>
                <FMContainer square={true} className={this.props.classes.infoBlockBody}>
                    <FMTable>
                        <FMTableHead>
                            <FMTableRow>
                                {
                                    this.props.sensorCaptions.map(pair =>
                                        <FMTableCell
                                            key={pair.key}
                                            className={this.props.classes.tableHead}
                                        >
                                            {pair.value}
                                        </FMTableCell>
                                    )
                                }
                            </FMTableRow>
                        </FMTableHead>
                        <FMTableBody>
                            {
                                this.state.sensors.map(sensor =>
                                    <FMTableRow key={sensor[0].value}>
                                        {
                                            sensor.map(pair =>
                                                <FMTableCell key={pair.key}>{pair.value}</FMTableCell>
                                            )
                                        }
                                    </FMTableRow>
                                )
                            }
                        </FMTableBody>
                    </FMTable>
                </FMContainer>
            </FMContainer>
        );
    }

}

export default withStyles(style)(DeviceInfoPane);
